import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import { CognitoService } from './../../services/cognito/cognito.service';
import { LoginService } from './login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  email: FormControl;
  password: FormControl;
  region: FormControl;
  showAlert = false;
  regionsList = this.activatedRoute.snapshot.data.regions;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cognitoService: CognitoService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    // this.createFormControls();
    // this.createForm();
    if (this.cognitoService.isAuthenticated) {
      this.router.navigate(['dashboard']);
    }
  }

  createFormControls(): void {
    this.email = new FormControl('', {
      validators: Validators.required
    });
    this.password = new FormControl('', {
      validators: Validators.required
    });
    this.region = new FormControl('', {
      validators: Validators.required
    });
  }

  createForm(): void {
    this.loginForm = new FormGroup({
      email: this.email,
      password: this.password,
      region: this.region
    });
  }

  loginSubmit(): any {
    const self = this;

    this.dirtyForm(this.loginForm);

    if (this.loginForm.valid) {
      this.cognitoService.authenticateUser(
        this.email.value,
        this.password.value
        , result => {
          const region = this.stringifyValue(this.region.value, false);

          localStorage.setItem('region-api', 'https://' + region.host + region.endpoint);
          localStorage.setItem('region-id', region.awsRegionId);

          self.router.navigate(['/dashboard']);
        }, err => {
          self.showAlert = true;

          setTimeout(() => {
            self.showAlert = false;
          }, 3000);
        });
    }
  }

  private stringifyValue(value, action) {
    if (action) {
      return JSON.stringify(value);
    } else {
      return JSON.parse(value);
    }
  }

  private dirtyForm(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {
      const control = form.controls[key];

      if (control instanceof FormGroup) {
        return this.dirtyForm(control);
      }

      control.markAsDirty();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/login.component.ts